import React from 'react'
import './Style/payment.css'
function Payment({total,discount,lastPrice,info,customerInfo}) {
  return <div className='payment grid grid-cols-2 md:px-20 px-4 mb-5'>

      <div className='col-span-1 md:mt-32 mt-4 z-20'>
            <div className='md:mb-10 mb-4'>
                    <h1 className='text-main-color font-bold text-xl'> Invoive to: </h1>
                    <p className='md:text-white text-black '> {customerInfo.info.name} </p>
                    <p className='md:text-white text-black '> {customerInfo.info.address} </p>
                    <p className='mb-10 w-8/12 border-b-2 pb-10 border-white md:text-white text-black '> Location : {customerInfo.info.location} </p>
            </div>
            <div>
                <h1 className='text-main-color font-bold text-xl'>  Terms & Conditions  </h1>
                <p className='conditions w-8/12 text-white'> Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex voluptas cum fugit nostrum amet omnis, </p>
                <p className='mt-5 text-white'> Thank you For Your Business❤️ </p>
            </div>
      </div>

    
        


      <div className='col-span-1'>
        <div className='productInfo w-full  md:px-10 px-4 '>
                <div className='flex justify-between items-center flex-col'>
                    <div className='w-full p-1 flex justify-between items-center mt-0'>
                        <p className='mt-3 font-medium'>Sub Title</p>
                        <p className='mt-3 font-medium'>{total}$</p>
                    </div>
                    <div className='w-full p-1 flex justify-between items-center mt-3'>
                        <p className='mt-3 font-medium'>Discount(%{info.discount})</p>
                        <p className='mt-3 font-medium'>{discount}$</p>
                    </div>
                    <div className='w-full p-1 border-t-2  border-black flex justify-between items-center mt-3'>
                        <p className='text-lg font-bold mt-3 text-main-color'>Total</p>
                        <p className='mt-3 font-bold text-main-color'>{lastPrice}$</p>
                    </div>
                </div>
            </div>
      </div>
  </div>
}

export default Payment